import { Link } from 'react-router-dom';
import { posts } from '@/mocks/posts';

export default function HotRanking() {
  const ranked = [...posts].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const [top, ...rest] = ranked;

  return (
    <section className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
      <div className="grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-accent-600">
            <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center" />
            HOT RANKING
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            今日热瓜榜
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            按吃瓜热度实时排序，每分钟刷新一次。想知道今天大家在笑什么，看这一榜就够了。
          </p>

          <article className="mt-6 overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
            <Link to={`/post/${top.id}`} className="group block">
              <div className="h-48 w-full overflow-hidden bg-background-200">
                <img
                  src={top.cover}
                  alt={`${top.title} - 今日热瓜榜第一名`}
                  title={`${top.title} 糖心吃瓜网`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  <i className="ri-trophy-line w-3.5 h-3.5 flex items-center justify-center" />
                  榜首 · 热度 {top.heat}
                </span>
                <h3 className="mt-3 line-clamp-2 text-base font-medium text-foreground-900 group-hover:text-primary-700">
                  {top.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{top.excerpt}</p>
              </div>
            </Link>
          </article>
        </div>

        <div className="lg:col-span-8">
          <div className="grid gap-3 sm:grid-cols-2">
            {rest.map((post, index) => (
              <Link
                key={post.id}
                to={`/post/${post.id}`}
                className="group flex items-start gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/50"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg ${
                    index < 2
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {index + 2}
                </span>
                <div className="min-w-0">
                  <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                    {post.title}
                  </h3>
                  <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                    <span className="text-secondary-700">{post.channelName}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line w-3.5 h-3.5 flex items-center justify-center" />
                      {post.likes}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center" />
                      {post.comments}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}